// DataPrivacyPage.tsx — (tf3-34) Settings → Data and privacy: per platform, what TubeForge reads and keeps, what for, how to
// revoke and how to delete (lib/data-privacy.ts).
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/Card.tsx";
import { DATA_PRIVACY, DELETE_WORDS } from "@/lib/data-privacy.ts";

export function DataPrivacyPage() {
  return (
    <div className="mx-auto max-w-4xl p-8">
      <h1 className="mb-2 text-3xl font-bold text-fg">Data and privacy</h1>
      <p className="mb-6 text-fgMuted">What TubeForge reads from each platform you connect, what it keeps, and how to take it back. See also our <Link className="underline" to="/privacy">Privacy Policy</Link>.</p>
      {DATA_PRIVACY.map((p) => (
        <Card key={p.platform} className="mb-4">
          <CardHeader><CardTitle>{p.platform}</CardTitle></CardHeader>
          <CardContent>
            <dl className="text-sm">
              <dt className="font-medium text-fg">What we read</dt><dd className="mb-2 text-fgMuted">{p.reads}</dd>
              <dt className="font-medium text-fg">What we keep</dt><dd className="mb-2 text-fgMuted">{p.keeps}</dd>
              <dt className="font-medium text-fg">What for</dt><dd className="mb-2 text-fgMuted">{p.usedFor}</dd>
              <dt className="font-medium text-fg">How to revoke</dt><dd className="mb-2 text-fgMuted">{p.revoke}</dd>
            </dl>
            {p.links && <p className="text-xs">{p.links.map((l, i) => <span key={l.href}>{i ? " · " : ""}<a className="underline" href={l.href} target="_blank" rel="noreferrer">{l.label}</a></span>)}</p>}
          </CardContent>
        </Card>))}
      <p className="text-sm text-fgMuted">{DELETE_WORDS}</p>
    </div>
  );
}
